import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { listsetting1, useropen } from '../../redux/userInfo';
import { open, close, loadingflas, listupdater } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '../../component/Button';
import Select from '../../component/Select';
import Radios from '../../component/Radios';
import Input from '../../component/Input';
import ListsettingPop from '../../component/ListsettingPop';
import ProductDetailPop from '../../component/ProductDetailPop';
import ProductSendPop from '../../component/ProductSendPop';
import ProductTogetherPop from '../../component/ProductTogetherPop';

// 신규 컴포넌트123123123 123123123
import SelectClick from '../../component/SelectClick';
import PlusMinusBox from '../../component/PlusMinusBox';

// 신규 모듈
import { useMediaQuery } from 'react-responsive'
import _ from "lodash"
import { isMobile } from 'react-device-detect';

import { Map, DrawingManager, MarkerClusterer, MapMarker, CustomOverlayMap } from "react-kakao-maps-sdk"
import AddrSelector from '../../component/AddrSelector';
import * as APIS from "../../utils/service";

import {
    getMemberinfo, numFormat, useIntersectionObserver, polygon_point_check, filterItems, geKoreanNumber, koreaNumber,
    hpHypen
} from "../../utils/utils";
import Checkbox from '../../component/Checkbox';
import consts from '../../libs/consts';
import ProductDetailwrite from '../../component/ProductDetailwrite';

const { kakao } = window;

export default function MiniPageMap({
    latlng,
    memberinfos,
    positionLists,
    showbtn = false,
    show,
    setShow,
    mobileBackControl, // 모바일 전용 함수

    // 매물 종류
    configArr,
    setConfigArr,
    setConfigReset,

    // 거래 유형/가격
    sell_type,  // 매매 전세 월세
    setsell_type,
    sell_type_list,// 매매 전세 월세 리스트
    setsell_type_list,
    price_sell_min, // 매매가 최소
    setprice_sell_min,
    price_sell_max, // 매매가 최대
    setprice_sell_max,
    price_all_min, // 전세 보증금 최소
    setprice_all_min,
    price_all_max, // 전세 보증금 최대
    setprice_all_max,
    price_all_month_min, // 월세 보증금 최소
    setprice_all_month_min,
    price_all_month_max, // 월세 보증금 최대
    setprice_all_month_max,
    price_month_min, // 월세 최소
    setprice_month_min,
    price_month_max, // 월세 최대
    setprice_month_max,

    // 면적, 방수, 층
    area_type, // 1=평, 2=m²
    setarea_type,
    area_private_min, // 전용면적 최소
    setarea_private_min,
    area_private_max, // 전용면적 최대
    setarea_private_max,
    item_room, // 방수 1=1개, 2=2개, 3=3개, 4=4개 이상
    // setitem_room,
    item_room_list,
    setitem_room_list,
    
    // building_floor_min, // 희망층 최소
    // setbuilding_floor_min,
    // building_floor_max, // 희망층 최대
    // setbuilding_floor_max,

    floor_config, // 희망층 설정 리스트
    building_floor_arr, // 희망층 idx
    setbuilding_floor_arr,

    area_floor_min, // 건물 연면적 최소
    setarea_floor_min,
    area_floor_max, // 건물 연면적 최대
    setarea_floor_max,
    area_land_min, // 토지면적 최소
    setarea_land_min,
    area_land_max, // 토지면적 최대
    setarea_land_max,
    building_dong_floor_all_min, // 희망 총 층수 최소
    setbuilding_dong_floor_all_min,
    building_dong_floor_all_max, // 희망 총 층수 최대
    setbuilding_dong_floor_all_max,

    floorType,
    setFloorType,

    // 지도에서 클릭한 클러스터 idx값들
    clusterIdx,
    setClusterIdx,

    // 지도 움직였을때 클러스터 클릭한 리스트 초기화
    setClusterReset,

    // filterFunc 실행
    filterFunc=()=>{}

}) {
    // console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!해시변경?');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const managerRef = useRef(null);
    const mapRef = useRef(null);
    const clustererRef = useRef(null);
    const target = useRef(null);
    const leftdivref = useRef(null);

    const PRICE_UNIT = 10000

    const { configdata } = useSelector(s => s.configReducer);
    const { listupdate } = useSelector(s => s.popupReducer);
    const { userdata, companylogourl } = useSelector(s => s.userInfo);

    const width = window.innerWidth;
    const height = window.innerHeight;

    // 반응형 설정
    const is830 = useMediaQuery({ query: "(max-width : 830px)" });
    const is540 = useMediaQuery({ query: "(max-width : 540px)" });
    const is500 = useMediaQuery({ query: "(max-width : 500px)" });
    const is480 = useMediaQuery({ query: "(max-width : 480px)" });

    // 팝업
    const [config01, setConfig01] = useState(false);
    const [config02, setConfig02] = useState(false);
    const [config03, setConfig03] = useState(false);
    const [config04, setConfig04] = useState(false);

    const [clurChk, setclurChk] = useState(false);
    const [clickClur, setClickClur] = useState([]);

    
    // 250402 추가 state
    const [mapLoad, setMapLoad] = useState(false);
    const [configLoad, setConfigLoad] = useState(true);
    const [selectPin, setSelectPin] = useState(''); // 선택한 customOverlay 확인용
    const [selectClurArr, setSelectClurArr] = useState([]); // MarkerClusterer 확인용

    // useEffect(() => {
    //     setTimeout(() => {
    //         setMapLoad(false);
    //     }, 2000);
    // }, [])
    
    useEffect(() => {
        // console.log('>>>>>> ', configLoad);
        // console.log('>>>>>> ', configArr);

        if(configLoad && configArr?.length > 0) {
            setConfigLoad(false);
            filterFunc();
        }
    }, [configArr])

    // 매물종류 초기화 함수
    useEffect(() => {
        if(mapLoad) return;
        if(configArr?.length === 0) {
            filterFunc();
        }
    }, [configArr]);
    
    // 거래 유형/가격 초기화 함수
    useEffect(() => {
        if(mapLoad) return;
        if (
            sell_type_list?.length === 0 &&
            price_sell_min === 0 &&
            price_sell_max === 0 &&
            price_all_min === 0 &&
            price_all_max === 0 &&
            price_all_month_min === 0 &&
            price_all_month_max === 0 &&
            price_month_min === 0 &&
            price_month_max === 0
        ) {
            filterFunc();
        }
    }, [
        sell_type_list, price_sell_min, price_sell_max, 
        price_all_min, price_all_max, price_all_month_min, price_all_month_max, 
        price_month_min, price_month_max
    ]);

    // 면적 초기화
    useEffect(() => {
        if(mapLoad) return;
        if(
            area_type === 1 &&
            area_private_min === 0 &&
            area_private_max === 0 &&
            area_floor_min === 0 &&
            area_floor_max === 0 &&
            area_land_min === 0 &&
            area_land_max === 0 &&
            building_dong_floor_all_min === 0 &&
            building_dong_floor_all_max === 0
        ) {
            filterFunc();
        }
    }, [
        area_type, area_private_min, area_private_max, 
        area_floor_min, area_floor_max, area_land_min, area_land_max,
        building_dong_floor_all_min, building_dong_floor_all_max
    ]);

    // 방/층수 초기화
    useEffect(() => {
        if(mapLoad) return;
        if(
            item_room_list?.length === 0 &&
            building_floor_arr?.length === 0
        ) {
            filterFunc();
        }
    }, [item_room_list, building_floor_arr]);
   

    const changeTitle = (idx) => {
        let result = ""
        if (idx === 2) // 다세대
            result = "빌라·연립"
        if (idx === 3) // 단독/다가구
            result = "원·투룸"
        if (idx === 4)
            result = "주거용 오피스텔"
        if (idx === 8)
            result = "업무용 오피스텔"
        return result
    }
    
    //메물 카테고리 그룹핑
    const maemulCategoryList = (categoryList = []) => {
        if (categoryList.length > 0) {
            const groupList = _.groupBy(categoryList, "category_1")
            return Object.keys(groupList).reduce((arr, key) => {
                if (groupList[key]) {
                    // 이름 변경
                    let changeNameList = groupList[key].map(v => {
                        let changeName = v.title
                        if (v.idx === 2) // 다세대
                            changeName = changeTitle(2)
                        if (v.idx === 3) // 단독/다가구
                            changeName = changeTitle(3)
                        if (v.idx === 4)
                            changeName = changeTitle(4)
                        if (v.idx === 8)
                            changeName = changeTitle(8)
                        return { ...v, title: changeName }
                    })
                    arr.push(changeNameList)
                }
                return arr
            }, [])
        } else {
            return []
        }
    }

    /**
     * 필터에 따른 버튼 텍스트
     * @param {"conf1"|"conf2"|"conf3"} type 필터 유형
     * @param {string} defaultTitle 기본 타이틀
     * @returns 
     */
    const getFilterTitle = (type, defaultTitle) => {
        if (type === "conf1" && configArr.length > 0) {
            let titleList = configdata?.consts?.category_2_OptionConsts.filter(v => {
                return configArr.includes(v.idx)
            })
            return titleList.map(v => {
                return changeTitle(v.idx) || v.title;
            }).toString()

        } else if (type === "conf2") {
            if (sell_type_list.length > 0) {
                let resultText = '';

                sell_type_list?.map((x, i) => {
                    if(i === 0) {
                        resultText += x?.names;
                    } else {
                        resultText += ',' + x?.names;
                    }
                    if(x?.names === '매매' && price_sell_min > 0 && price_sell_max > 0) {
                        resultText += `(${koreaNumber(price_sell_min)} ~ ${koreaNumber(price_sell_max)})`;
                    }
                    if(x?.names === '전세' && price_all_min > 0 && price_all_max > 0) {
                        resultText += `(${koreaNumber(price_all_min)} ~ ${koreaNumber(price_all_max)})`;
                    }
                    if(x?.names === '월세' && price_all_month_min > 0 && price_all_month_max > 0) {
                        resultText += `(${koreaNumber(price_all_month_min)} ~ ${koreaNumber(price_all_month_max)})`;
                    }
                    if(x?.names === '월세' && price_month_min > 0 && price_month_max > 0) {
                        resultText += `(${koreaNumber(price_month_min)} ~ ${koreaNumber(price_month_max)})`;
                    }
                });

                return resultText;
                // return sell_type_list.map(v => v.names).toString();
            }
        } else if (type === "conf3") {
            const addText = () => {
                if (area_type == 1) {
                    return "평"
                } else if (area_type == 2) {
                    return "m²"
                }
                return ""
            }

            let conf3TextList = []
            if (area_private_min || area_private_max) { //면적 
                let area_private = ""
                area_private = "전용 "
                if (area_private_min) {
                    area_private += area_private_min + addText()
                }

                if (area_private_max) {
                    area_private += "~" + area_private_max + addText()
                } else {
                    area_private += "~"
                }

                if (area_private) {
                    conf3TextList.push(area_private)
                }
            }

            // 250411 조건 삭제 => 토지 면적과 층수가 전체일때는 기본적으로 보이기 때문
            // if (configArr.filter(conf => [9, 10, 11].includes(conf)).length > 0) {
            // }

            if (area_floor_min || area_floor_max) {
                let area_floor_text = "건물연면적"
                if (area_floor_min) {
                    area_floor_text += area_floor_min + addText()
                }

                if (area_floor_max) {
                    area_floor_text += "~" + area_floor_max + addText()
                } else {
                    area_floor_text += "~"
                }
                conf3TextList.push(area_floor_text)
            }

            if (area_land_min || area_land_max) {
                let area_land_text = "토지"
                if (area_land_min) {
                    area_land_text += area_land_min + addText()
                }

                if (area_land_max) {
                    area_land_text += "~" + area_land_max + addText()
                } else {
                    area_land_text += "~"
                }
                conf3TextList.push(area_land_text)
            }

            
            if (building_dong_floor_all_min || building_dong_floor_all_max) {
                let building_dong_floor_all_text = "층수 "
                
                if (building_dong_floor_all_min) {
                    building_dong_floor_all_text += building_dong_floor_all_min
                }

                if (building_dong_floor_all_max) {
                    building_dong_floor_all_text += "~" + building_dong_floor_all_max
                } else {
                    building_dong_floor_all_text += "~"
                }
                conf3TextList.push(building_dong_floor_all_text)
            }

            if (conf3TextList.length > 0) return conf3TextList.toString();
        } else if (type === "conf4") {
            
            let conf4TextList = [];

            if (item_room_list.length > 0) { // 방수
                let makeRoomText = "방수 "
                let makeNumList = []
                item_room_list.sort();
                for (let roomNum of item_room_list) {
                    if(roomNum != 0) 
                        if (roomNum === 4)
                            makeNumList.push(roomNum + "개 이상")
                        else
                            makeNumList.push(roomNum + "개")
                }
                makeRoomText += makeNumList.toString();

                conf4TextList.push(makeRoomText);
            }

            if(building_floor_arr?.length > 0) {
                if(building_floor_arr?.includes(1)) conf4TextList.push('1층');
                if(building_floor_arr?.includes(2)) conf4TextList.push('저층');
                if(building_floor_arr?.includes(3)) conf4TextList.push('중간층');
                if(building_floor_arr?.includes(4)) conf4TextList.push('고층');
                if(building_floor_arr?.includes(5)) conf4TextList.push('탑층');
            }

            // if (building_floor_min || building_floor_max) { //층수
            //     let building_floor_text = ""

            //     if(building_floor_min === 1 && building_floor_max === 1) {
            //         conf4TextList.push('1층');
            //     }
            //     if(building_floor_min === 1 && building_floor_max === 33.33) {
            //         conf4TextList.push('저층');
            //     }
            //     if(building_floor_min === 33.34 && building_floor_max === 66.66) {
            //         conf4TextList.push('중층');
            //     }
            //     if(building_floor_min === 66.67 && building_floor_max === 100) {
            //         conf4TextList.push('고층');
            //     }
            //     if(building_floor_min === 100 && building_floor_max === 100) {
            //         conf4TextList.push('탑층');
            //     }

            //     // building_floor_text = "층 "
            //     // if (building_floor_min) {
            //     //     building_floor_text += building_floor_min
            //     // }

            //     // if (building_floor_max) {
            //     //     building_floor_text += "~" + building_floor_max
            //     // } else {
            //     //     building_floor_text += "~"
            //     // }

            //     // if (building_floor_text) {
            //     //     conf4TextList.push(building_floor_text)
            //     // }
            // }

            if (conf4TextList.length > 0) return conf4TextList.toString();
        }

        return defaultTitle
    }


    /**
     * 방 수 선택
     * @param {number} value 
     */
    const roomListSelectFunc = (value) => {
        if(value === 0) {
            setitem_room_list([]);
            return;
        }

        setitem_room_list(v => {
            if (!item_room_list.includes(value)) {
                v.push(value)
            } else {
                let delIndex = v.indexOf(value);
                v.splice(delIndex, 1)
            }
            return [...v]
        })
    }


    /* 클러스터 호버 이벤트 함수 추가 250401  핀 생성 이벤트*/
    const handleClustererCreate = (clusterer) => {
        // 클러스터러에 이벤트 리스너 추가
        clusterer.addListener("clustered", (clusters) => {
            for(var i=0; i<clusters.length; i++){            
                var cluster = clusters[i];
                var overlay = cluster.getClusterMarker().getContent();
                
                // 각 클러스터의 overlay에 mouseover 이벤트를 등록합니다.
                overlay?.addEventListener('mouseover', function() {
                    if(!this.classList.contains('cluster_hover')) {      
                        this.classList.add('cluster_hover');
                    }
                });
                
                // 각 클러스터의 overlay에 mouseout 이벤트를 등록합니다.
                overlay?.addEventListener('mouseout', function() {
                    if(this.classList.contains('cluster_hover')) {
                        this.classList.remove('cluster_hover');
                    }
                });

                
                // overlay?.addEventListener('click', function() {
                //     console.log("Cluster clicked:", this);

                //     if(!this.classList.contains('cluster_click')) {
                //         this.classList.add('cluster_click');
                //     }
                // });
                
            }
        });

        // clusterer.addListener("clusterclick", (cluster) => {
        //     const overlay = cluster.getClusterMarker().getContent();
        //     console.log('>>>>> ', overlay.style.background);
        //     overlay.style.background = '#000';

        //     // if (!overlay.classList.contains('cluster_hover02')) {
        //     //     overlay.classList.add('cluster_hover02');
        //     // }
        // });
    }

    const configFunc = (idx) => {
        // 상가를 눌렀을때 바로 리스트 반영되는걸 막기 위해 추가
        setConfigLoad(false);

        if (configArr?.includes(idx)) {
            setConfigArr(configArr?.filter(v => v != idx));
        } else {
            setConfigArr([...configArr, idx]);
        }
    }

    
    let config01_option_list01 = [
        {idx: 1, category_1: 1, title: '아파트', group: '집합건물'},
        {idx: 4, category_1: 1, title: '주거용 오피스텔', group: '집합건물'},
        {idx: 8, category_1: 2, title: '업무용 오피스텔', group: '집합건물'},
    ]

    let config01_option_list02 = [
        {idx: 2, category_1: 1, title: '빌라·연립', group: '집합건물'},
        {idx: 10, category_1: 3, title: '상가주택', group: '일반건물'},
        {idx: 11, category_1: 3, title: '주거전용건물', group: '일반건물'},
    ]

    let config01_option_list03 = [
        {idx: 3, category_1: 1, title: '원룸·투룸', group: '일반건물'},
    ]

    let config01_option_list04 = [
        {idx: 5, category_1: 2, title: '상가', group: '집합건물'},
        {idx: 6, category_1: 2, title: '사무실', group: '집합건물'},
        {idx: 7, category_1: 2, title: '지식산업센터', group: '집합건물'},
        {idx: 9, category_1: 3, title: '빌딩/상업용건물', group: '집합건물'},
    ]

    let room_config = [
        {
            idx: 0,
            title: '전체'
        },
        {
            idx: 1,
            title: '1개'
        },
        {
            idx: 2,
            title: '2개'
        },
        {
            idx: 3,
            title: '3개'
        },
        {
            idx: 4,
            title: '4개 이상'
        },
    ]

    

    return (
        <>
            <div className='mini_home_right'>
                {!(show && is830) && <div className='mini_home_map_config'>
                    <div className='mini_home_map_config_sub'>
                        <SelectClick
                            show={config01}
                            setShow={(res) => {
                                setConfig01(res);
                                if (res) {
                                    setConfig02(false);
                                    setConfig03(false);
                                    setConfig04(false);
                                }
                            }}
                            oriTitle={"매물 종류"}
                            styles={{
                                maxWidth:230
                            }}
                            title={getFilterTitle("conf1", "매물 종류")}
                        />

                        <SelectClick
                            show={config02}
                            setShow={(res) => {
                                setConfig02(res);
                                if (res) {
                                    setConfig01(false);
                                    setConfig03(false);
                                    setConfig04(false);
                                }
                            }}
                            oriTitle={"거래 유형/가격"}
                            styles={{
                                maxWidth:160
                            }}
                            title={getFilterTitle("conf2", '거래 유형/가격')}
                        />

                        <SelectClick
                            show={config03}
                            setShow={(res) => {
                                setConfig03(res);
                                if (res) {
                                    setConfig01(false);
                                    setConfig02(false);
                                    setConfig04(false);
                                }
                            }}
                            oriTitle={'면적'}
                            styles={{
                                maxWidth:130
                            }}
                            title={getFilterTitle("conf3", '면적')}
                        />

                        <SelectClick
                            show={config04}
                            setShow={(res) => {
                                setConfig04(res);
                                if (res) {
                                    setConfig01(false);
                                    setConfig02(false);
                                    setConfig03(false);
                                }
                            }}
                            oriTitle={'방/층수'}
                            styles={{
                                maxWidth:130
                            }}
                            title={getFilterTitle("conf4", '방/층수')}
                        />
                    </div>
                    
                    {/* 선택 박스 */}
                    {(config01 || config02 || config03 || config04) &&
                        <div className='mini_map_config_container'>
                            <div className='mini_map_x_top' style={{ marginBottom: is540 ? 15 : 0 }}>
                                <div className='mini_config_x_box'
                                    onClick={() => {
                                        setConfig01(false);
                                        setConfig02(false);
                                        setConfig03(false);
                                        setConfig04(false);
                                    }}
                                >
                                    <img src="./images/icons/x_black.svg" width={is500 ? `30` : `24`} />
                                </div>
                            </div>

                            <div className='mini_map_config_box' >

                                <div className='mini_home_config_top' style={{
                                    paddingBottom: config03 ? 0 : undefined
                                }}>
                                    <p className='mini_home_config_title'>
                                        {config01 && '매물 종류'}
                                        {config02 && '거래 유형/가격'}
                                        {config03 && '면적'}
                                        {config04 && '방/층수'}
                                    </p>
                                    
                                    {config01 &&
                                        <div className='config01_toggle_title_box'>
                                            <p>전체보기</p>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (setConfigReset) {
                                                        setConfigReset();
                                                    }
                                                }}
                                                style={{
                                                    backgroundColor: configArr?.length ? '#E8E9EA' : '#6164A5', 
                                                    justifyContent: configArr?.length ? 'flex-start' : 'flex-end',
                                                    borderRadius: 100, 
                                                    width: 40, 
                                                    padding: 3,
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                }}
                                            >
                                                <span style={{ borderRadius: '100%', width: 18, height: 18, display: 'flex', backgroundColor: '#fff'}} />
                                            </button>
                                        </div>
                                    }

                                </div>
                                
                                {config03 && 
                                    <div className="searchetcselect">
                                        <div>
                                            <Radios
                                                linetype={'radioimg'}
                                                values={area_type}
                                                setvalues={(e) => {
                                                    setarea_type(e);
                                                }}
                                                namevalue={[
                                                    { names: '평', values: 1 },
                                                    { names: 'm²', values: 2 },
                                                ]}
                                                fontweights={400}
                                                fontSizes={14}
                                                sizes={20}
                                                gap={20}
                                            />
                                        </div>
                                    </div>
                                }

                                {config01 &&
                                    <>
                                        <div>
                                            <div className='config_popup'>
                                                <p>아파트ㆍ오피스텔</p>
                                                <div className='config01_option_list'>
                                                    {config01_option_list01?.map((x, i) => {
                                                        return (
                                                            <p key={i}
                                                                className={configArr?.includes(x?.idx) ? 'active' : ''}
                                                                onClick={() => {
                                                                    configFunc(x?.idx);
                                                                }}
                                                            >{x?.title}</p>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                            
                                            <div className='config_popup'>
                                                <p>빌라ㆍ주택</p>
                                                <div className='config01_option_list'>
                                                    {config01_option_list02?.map((x, i) => {
                                                        return (
                                                            <p key={i}
                                                                className={configArr?.includes(x?.idx) ? 'active' : ''}
                                                                onClick={() => {
                                                                    configFunc(x?.idx);
                                                                }}
                                                            >{x?.title}</p>
                                                        )
                                                    })}
                                                </div>
                                            </div>

                                            <div className='config_popup'>
                                                <p>원ㆍ투룸</p>
                                                <div className='config01_option_list'>
                                                    {config01_option_list03?.map((x, i) => {
                                                        return (
                                                            <p key={i}
                                                                className={configArr?.includes(x?.idx) ? 'active' : ''}
                                                                onClick={() => {
                                                                    configFunc(x?.idx);
                                                                }}
                                                            >{x?.title}</p>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                            
                                            <div className='config_popup'>
                                                <p>상가ㆍ업무</p>
                                                <div className='config01_option_list'>
                                                    {config01_option_list04?.map((x, i) => {
                                                        return (
                                                            <p key={i}
                                                                className={configArr?.includes(x?.idx) ? 'active' : ''}
                                                                onClick={() => {
                                                                    configFunc(x?.idx);
                                                                }}
                                                            >{x?.title}</p>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='reset_box' style={{ paddingTop: 20 }}>
                                            <Button
                                                buttonTxt={'초기화'}
                                                className={'resetbutton'}
                                                titleimgs={`./images/icons/loop-left-line.svg`}
                                                onPress={() => {
                                                    if(setConfigReset) setConfigReset();
                                                    filterFunc();
                                                    setConfig01(false);
                                                }}
                                            />
                                            <Button
                                                buttonTxt={'적용하기'}
                                                className={'success_button'}
                                                onPress={() => {
                                                    setConfig01(false);
                                                    filterFunc();
                                                }}
                                            />
                                        </div>
                                    </>
                                }

                                {config02 &&
                                    <>
                                        {/* -------- new start ---------- */}
                                        <div className='config02_check_list'>
                                            <Checkbox
                                                linetype={'checkimg'}
                                                values={sell_type_list}
                                                setvalues={setsell_type_list}
                                                namevalue={[
                                                    { names: '매매', values: "매매" },
                                                ]}
                                                fontweights={400}
                                                fontSizes={14}
                                                sizes={20}
                                                gapSize={8}
                                            />
                                            <Checkbox
                                                linetype={'checkimg'}
                                                values={sell_type_list}
                                                setvalues={setsell_type_list}
                                                namevalue={[
                                                    { names: '전세', values: "전세" },
                                                ]}
                                                fontweights={400}
                                                fontSizes={14}
                                                sizes={20}
                                                gapSize={8}
                                            />
                                            <Checkbox
                                                linetype={'checkimg'}
                                                values={sell_type_list}
                                                setvalues={setsell_type_list}
                                                namevalue={[
                                                    { names: '월세', values: "월세" },
                                                ]}
                                                fontweights={400}
                                                fontSizes={14}
                                                sizes={20}
                                                gapSize={8}
                                            />
                                        </div>

                                        {sell_type_list?.filter(x => x.values === '매매')?.length > 0 &&
                                            <>
                                                <div style={{ marginBottom: 20 }}>
                                                    <div className='mini_home_popup'>
                                                        <p className='title'>매매</p>
                                                        <div className='flex_info_input flex_pm_box'>
                                                            <PlusMinusBox
                                                                values={koreaNumber(price_sell_min)}
                                                                numValue={price_sell_min / PRICE_UNIT}
                                                                setValues={(res) => {
                                                                    setprice_sell_min(res * PRICE_UNIT);
                                                                }}
                                                                placeHolder={'최소'}
                                                                minusOff={price_sell_min < 10000000 ? true : false}
                                                                plusFunc={(res) => {
                                                                    if (price_sell_max != 0 && price_sell_max <= res * PRICE_UNIT) {
                                                                        setprice_sell_max(res * PRICE_UNIT);
                                                                    }
                                                                }}
                                                                unit={7}
                                                            />

                                                            <p className='wave_text'>~</p>

                                                            <PlusMinusBox
                                                                values={koreaNumber(price_sell_max)}
                                                                numValue={price_sell_max / PRICE_UNIT}
                                                                setValues={(res) => {
                                                                    setprice_sell_max(res * PRICE_UNIT);
                                                                }}
                                                                placeHolder={'최대'}
                                                                minusOff={price_sell_max <= price_sell_min ? true : false}
                                                                unit={7}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="searchetcselect" style={{ paddingTop: 16, borderTop: "1px solid #E8E9EA" }} />
                                            </>
                                        }

                                        {sell_type_list?.filter(x => x.values === '전세')?.length > 0 &&
                                            <>
                                                <div style={{ marginBottom: 20 }}>
                                                    <div className='mini_home_popup'>
                                                        <p className='title'>전세</p>
                                                        <div className='flex_info_input'>
                                                            <PlusMinusBox
                                                                values={koreaNumber(price_all_min)}
                                                                numValue={price_all_min / PRICE_UNIT}
                                                                setValues={(res) => {
                                                                    setprice_all_min(res * PRICE_UNIT);
                                                                }}
                                                                placeHolder={'최소'}
                                                                minusOff={price_all_min < 10000000 ? true : false}
                                                                plusFunc={(res) => {
                                                                    if (price_all_max != 0 && price_all_max <= res * PRICE_UNIT) {
                                                                        setprice_all_max(res * PRICE_UNIT);
                                                                    }
                                                                }}
                                                                unit={7}
                                                            />

                                                            <p className='wave_text'>~</p>

                                                            <PlusMinusBox
                                                                values={koreaNumber(price_all_max)}
                                                                numValue={price_all_max / PRICE_UNIT}
                                                                setValues={(res) => {
                                                                    setprice_all_max(res * PRICE_UNIT);
                                                                }}
                                                                placeHolder={'최대'}
                                                                minusOff={price_all_max <= price_all_min ? true : false}
                                                                unit={7}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="searchetcselect" style={{ paddingTop: 16, borderTop: "1px solid #E8E9EA" }} />
                                            </>
                                        }

                                        {sell_type_list?.filter(x => x.values === '월세')?.length > 0 &&
                                            <div style={{ marginBottom: 36 }}>
                                                <div>
                                                    <div className='mini_home_popup'>
                                                        <p className='title'>월세보증금</p>
                                                        <div className='flex_info_input'>
                                                            <PlusMinusBox
                                                                values={koreaNumber(price_all_month_min)}
                                                                numValue={price_all_month_min / PRICE_UNIT}
                                                                setValues={(res) => {
                                                                    setprice_all_month_min(res * PRICE_UNIT);
                                                                }}
                                                                placeHolder={'최소'}
                                                                minusOff={price_all_month_min < 10000000 ? true : false}
                                                                plusFunc={(res) => {
                                                                    if (price_all_month_max != 0 && price_all_month_max <= res * PRICE_UNIT) {
                                                                        setprice_all_month_max(res * PRICE_UNIT);
                                                                    }
                                                                }}
                                                                unit={7}
                                                            />

                                                            <p className='wave_text'>~</p>

                                                            <PlusMinusBox
                                                                values={koreaNumber(price_all_month_max)}
                                                                numValue={price_all_month_max / PRICE_UNIT}
                                                                setValues={(res) => {
                                                                    setprice_all_month_max(res * PRICE_UNIT);
                                                                }}
                                                                placeHolder={'최대'}
                                                                minusOff={price_all_month_max <= price_all_month_min ? true : false}
                                                                unit={7}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='mini_home_popup' style={{ marginTop: 12 }}>
                                                        <p className='title'>월세</p>
                                                        <div className='flex_info_input'>
                                                            <PlusMinusBox
                                                                values={koreaNumber(price_month_min)}
                                                                numValue={price_month_min / PRICE_UNIT}
                                                                setValues={(res) => {
                                                                    setprice_month_min(res * PRICE_UNIT);
                                                                }}
                                                                placeHolder={'최소'}
                                                                minusOff={price_month_min < 100000 ? true : false}
                                                                plusFunc={(res) => {
                                                                    if (price_month_max != 0 && price_month_max <= res * PRICE_UNIT) {
                                                                        setprice_month_max(res * PRICE_UNIT);
                                                                    }
                                                                }}
                                                                unit={5}
                                                            />

                                                            <p className='wave_text'>~</p>

                                                            <PlusMinusBox
                                                                values={koreaNumber(price_month_max)}
                                                                numValue={price_month_max / PRICE_UNIT}
                                                                setValues={(res) => {
                                                                    setprice_month_max(res * PRICE_UNIT);
                                                                }}
                                                                placeHolder={'최대'}
                                                                minusOff={price_month_max <= price_month_min ? true : false}
                                                                unit={5}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }


                                        <div className='reset_box'>
                                            <Button
                                                buttonTxt={'초기화'}
                                                className={'resetbutton'}
                                                titleimgs={`./images/icons/loop-left-line.svg`}
                                                onPress={async () => {

                                                    // 거래 유형 선택 초기화
                                                    setsell_type_list([]);

                                                    // 매매 보증금 초기화
                                                    setprice_sell_min(0);
                                                    setprice_sell_max(0);

                                                    // 전세 보증금 초기화
                                                    setprice_all_min(0);
                                                    setprice_all_max(0);

                                                    // 월세 및 월 보증금 초기화
                                                    setprice_all_month_min(0);
                                                    setprice_all_month_max(0);
                                                    setprice_month_min(0);
                                                    setprice_month_max(0);
                                                    
                                                    setConfig02(false);
                                                    // filterFunc();
                                                }}
                                            />
                                            <Button
                                                buttonTxt={'적용하기'}
                                                className={'success_button'}
                                                onPress={() => {
                                                    setConfig02(false);
                                                    filterFunc();
                                                }}
                                            />
                                        </div>


                                        {/* -------- new end ---------- */}

                                    </>
                                }

                                {config03 &&
                                    <>
                                        <div style={{ marginTop: 8 }}>
                                            <div className='mini_home_popup'>
                                                <p className='title' style={{ width: 80 }}>전용 면적</p>
                                                <div className='flex_info_input'>
                                                    <PlusMinusBox
                                                        values={koreaNumber(area_private_min)}
                                                        numValue={area_private_min}
                                                        setValues={(res) => {
                                                            setarea_private_min(res);
                                                        }}
                                                        placeHolder={'최소면적'}
                                                        minusOff={area_private_min <= 0 ? true : false}
                                                        plusFunc={(res) => {
                                                            if (area_private_max != 0 && area_private_max <= res) {
                                                                setarea_private_max(res);
                                                            }
                                                        }}
                                                        unit={0}
                                                        maxLength={7}
                                                    />

                                                    <p className='wave_text'>~</p>

                                                    <PlusMinusBox
                                                        values={koreaNumber(area_private_max)}
                                                        numValue={area_private_max}
                                                        setValues={(res) => {
                                                            setarea_private_max(res);
                                                        }}
                                                        placeHolder={'최대면적'}
                                                        minusOff={area_private_max <= area_private_min ? true : false}
                                                        unit={0}
                                                        maxLength={7}
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                        {/* {(configArr.includes(9) || configArr.includes(10) || configArr.includes(11)) && <> */}

                                        {((configArr.filter(conf => [9, 10, 11].includes(conf)).length > 0) || configArr?.length === 0) &&
                                            <>
                                                {/* <div className='title' style={{ paddingTop: 20, borderTop: "1px solid #ccc" }}>
                                                    <p>건물 전용 필터 </p>
                                                </div> */}

                                                <div style={{ marginTop: 16 }}>
                                                    {/* <div className='mini_home_popup'>
                                                        <p className='title' style={{ width: 80 }}>건물 연 면적</p>
                                                        <div className='flex_info_input'>
                                                            <PlusMinusBox
                                                                values={koreaNumber(area_floor_min)}
                                                                numValue={area_floor_min}
                                                                setValues={(res) => {
                                                                    setarea_floor_min(res);
                                                                }}
                                                                placeHolder={'최소 연면적'}
                                                                minusOff={area_floor_min <= 0 ? true : false}
                                                                plusFunc={(res) => {
                                                                    if (area_floor_max != 0 && area_floor_max <= res) {
                                                                        setarea_floor_max(res);
                                                                    }
                                                                }}
                                                                unit={0}
                                                                maxLength={7}
                                                            />

                                                            <p className='wave_text'>~</p>

                                                            <PlusMinusBox
                                                                values={koreaNumber(area_floor_max)}
                                                                numValue={area_floor_max}
                                                                setValues={(res) => {
                                                                    setarea_floor_max(res);
                                                                }}
                                                                placeHolder={'최대 연면적'}
                                                                minusOff={area_floor_max <= area_floor_min ? true : false}
                                                                unit={0}
                                                                maxLength={7}
                                                            />
                                                        </div>
                                                    </div> */}


                                                    <div className='building_option_config'>
                                                        <div className='mini_home_popup' style={{ marginTop: 16 }}>
                                                            <p className='title' style={{ width: 80 }}>토지 면적</p>
                                                            <div className='flex_info_input'>
                                                                <PlusMinusBox
                                                                    values={koreaNumber(area_land_min)}
                                                                    numValue={area_land_min}
                                                                    setValues={(res) => {
                                                                        setarea_land_min(res);
                                                                    }}
                                                                    placeHolder={'최소 토지면적'}
                                                                    minusOff={area_land_min <= 0 ? true : false}
                                                                    plusFunc={(res) => {
                                                                        if(area_land_max != 0 && area_land_max <= res) {
                                                                            setarea_land_max(res);
                                                                        }
                                                                    }}
                                                                    unit={0}
                                                                    maxLength={7}
                                                                />

                                                                <p className='wave_text'>~</p>

                                                                <PlusMinusBox
                                                                    values={koreaNumber(area_land_max)}
                                                                    numValue={area_land_max}
                                                                    setValues={(res) => {
                                                                        setarea_land_max(res);
                                                                    }}
                                                                    placeHolder={'최대 토지면적'}
                                                                    minusOff={area_land_max <= area_land_min ? true : false}
                                                                    unit={0}
                                                                    maxLength={7}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className='mini_home_popup' style={{ marginTop: 16 }}>
                                                            <p className='title' style={{ width: 80 }}>희망 총 층수</p>
                                                            <div className='flex_info_input'>
                                                                <PlusMinusBox
                                                                    values={koreaNumber(building_dong_floor_all_min)}
                                                                    numValue={building_dong_floor_all_min}
                                                                    setValues={(res) => {
                                                                        setbuilding_dong_floor_all_min(res);
                                                                    }}
                                                                    placeHolder={'희망 최소 층수'}
                                                                    minusOff={building_dong_floor_all_min <= 0 ? true : false}
                                                                    plusFunc={(res) => {
                                                                        if (building_dong_floor_all_max != 0 && building_dong_floor_all_max <= res) {
                                                                            setbuilding_dong_floor_all_max(res);
                                                                        }
                                                                    }}
                                                                    unit={0}
                                                                    maxLength={3}
                                                                />

                                                                <p className='wave_text'>~</p>

                                                                <PlusMinusBox
                                                                    values={koreaNumber(building_dong_floor_all_max)}
                                                                    numValue={building_dong_floor_all_max}
                                                                    setValues={(res) => {
                                                                        setbuilding_dong_floor_all_max(res);
                                                                    }}
                                                                    placeHolder={'희망 최대 층수'}
                                                                    minusOff={building_dong_floor_all_max <= building_dong_floor_all_min ? true : false}
                                                                    unit={0}
                                                                    maxLength={3}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </>
                                        }


                                        <div className='reset_box' style={{ marginTop: 36 }}>
                                            <Button
                                                buttonTxt={'초기화'}
                                                className={'resetbutton'}
                                                titleimgs={`./images/icons/loop-left-line.svg`}
                                                onPress={() => {
                                                    // setsell_type('');
                                                    
                                                    setarea_type(1);
                                                    setarea_private_min(0);
                                                    setarea_private_max(0);
                                                    setarea_floor_min(0);
                                                    setarea_floor_max(0);
                                                    setarea_land_min(0);
                                                    setarea_land_max(0);
                                                    setbuilding_dong_floor_all_min(0);
                                                    setbuilding_dong_floor_all_max(0);
                                                    
                                                    // 방수, 층수가 config04로 나뉨

                                                    setConfig03(false);
                                                }}
                                            />
                                            
                                            <Button
                                                buttonTxt={'적용하기'}
                                                className={'success_button'}
                                                onPress={() => {
                                                    setConfig03(false);
                                                    filterFunc();
                                                }}
                                            />
                                        </div>
                                    </>
                                }

                                {config04 &&
                                    <>
                                        <div className='mini_home_popup' style={{ marginTop: 20 }}>
                                            {/* <p className='title' style={{ width: 99 }}>방수</p> */}
                                            <div className='flex_info_input' style={{ width: '100%' }}>
                                                <div className='config_popup'>
                                                    <p>방수</p>
                                                    <div className='config01_option_list'>
                                                        {room_config?.map((x, i) => {
                                                            return (
                                                                <p key={i}
                                                                    className={(item_room_list?.includes(x?.idx) || (x?.title === '전체' && item_room_list?.length === 0)) ? 'active' : ''}
                                                                    onClick={() => {
                                                                        roomListSelectFunc(x?.idx);
                                                                    }}
                                                                >{x?.title}</p>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>

                                        <div className='mini_home_popup' style={{ marginTop: 20 }}>
                                            <div className='config_popup'>
                                                <p>층수</p>
                                                <div className='config01_option_list'>
                                                    {floor_config?.map((x, i) => {
                                                        return (
                                                            <p key={i}
                                                                className={
                                                                    ((building_floor_arr?.length === 0 && x?.idx === 0) || building_floor_arr?.includes(x?.idx)) ? 'active' : ''
                                                                }
                                                                onClick={() => {
                                                                    if(x?.idx === 0) {
                                                                        setbuilding_floor_arr([]);
                                                                        return;
                                                                    }

                                                                    if(building_floor_arr?.includes(x?.idx)){
                                                                        setbuilding_floor_arr(building_floor_arr?.filter(v => v != x?.idx));
                                                                    } else {
                                                                        setbuilding_floor_arr([...building_floor_arr, x?.idx]);
                                                                    }
                                                                    
                                                                    // setbuilding_floor_min(x?.min);
                                                                    // setbuilding_floor_max(x?.max);
                                                                }}
                                                            >{x?.title}</p>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='reset_box' style={{ marginTop: 36 }}>
                                            <Button
                                                buttonTxt={'초기화'}
                                                className={'resetbutton'}
                                                titleimgs={`./images/icons/loop-left-line.svg`}
                                                onPress={() => {
                                                    roomListSelectFunc(0);
                                                    setbuilding_floor_arr([])

                                                    // setbuilding_floor_min(0);
                                                    // setbuilding_floor_max(0);
                                                    
                                                    setConfig04(false);
                                                }}
                                            />
                                            
                                            <Button
                                                buttonTxt={'적용하기'}
                                                className={'success_button'}
                                                onPress={() => {
                                                    setConfig04(false);
                                                    filterFunc();
                                                }}
                                            />
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    }
                </div>}

                {memberinfos?.compony &&
                    <Map // 지도를 표시할 Container
                        id="map"
                        center={latlng}
                        style={{
                            // 지도의 크기
                            width: "100%",
                            height: "100%",
                        }}
                        onCenterChanged={(map) => {
                            setSelectPin('');
                            setSelectClurArr([]);

                            const latlng = map.getCenter();
                            // setlatlng({lat: latlng.getLat(), lng: latlng.getLng() });
                            if (clurChk) {
                                setclurChk(false);
                                if (setClusterReset) setClusterReset();
                            }
                        }}
                        level={6} // 최초 지도의 확대 레벨 6=500m
                        maxLevel={memberinfos?.compony?.minizoomlevel * 1}
                        ref={mapRef}
                    >

                        {positionLists?.length > 0 &&
                            <MarkerClusterer
                                ref={clustererRef}
                                averageCenter={true} // 클러스터에 포함된 마커들의 평균 위치를 클러스터 마커 위치로 설정
                                minLevel={1} // 클러스터 할 최소 지도 레벨
                                disableClickZoom={true}
                                setTexts={(size)=>{console.log("setText:",size)}}
                                onClusterclick={(target, cluster) => {
                                    let push = [];
                                    let lists = cluster?._markers;

                                    lists?.map((x, i) => {
                                        if (x?.a?.children[1]?.id) push.push((x?.a?.children[1]?.id * 1));
                                    });

                                    setSelectClurArr(push);
                                    if (push?.length > 0 && setClusterIdx) {
                                        if(isMobile){ // 모바일만
                                            setClusterIdx(push, 'list');
                                        } else {
                                            setClusterIdx(push);
                                        }
                                    }
                                    setclurChk(true); // 클러스터 초기화

                                    // target.setStyles([{
                                    //     width: '46px',
                                    //     height: '46px',
                                    //     background: 'rgba(255,255,255,0.9)',
                                    //     borderRadius: '23px',
                                    //     border: '2px solid #565BD2',
                                    //     color: '#fff',
                                    //     textAlign: 'center',
                                    //     fontSize: '18px',
                                    //     fontWeight: 'bold',
                                    //     lineHeight: '44px'
                                    // }])

                                    // cluster?._clusterer?.setStyles([
                                    //     {
                                    //         width: '46px',
                                    //         height: '46px',
                                    //         background: 'rgba(255,255,255,0.9)',
                                    //         borderRadius: '23px',
                                    //         border: '2px solid #565BD2',
                                    //         color: '#fff',
                                    //         textAlign: 'center',
                                    //         fontSize: '18px',
                                    //         fontWeight: 'bold',
                                    //         lineHeight: '44px',
                                    //     }
                                    // ])
                                    
                                    // const overlay = cluster?.getClusterMarker().getContent();
                                    // overlay.style.background = 'red';

                                }}
                                onCreate={handleClustererCreate}
                                styles={[
                                    {
                                        width: '46px',
                                        height: '46px',
                                        background: 'rgba(86,91,210,0.9)',
                                        borderRadius: '23px',
                                        border: '2px solid #565BD2',
                                        color: '#fff',
                                        textAlign: 'center',
                                        fontSize: '18px',
                                        fontWeight: 'bold',
                                        lineHeight: '44px',
                                    },
                                ]}
                            >
                                {positionLists?.length > 0 && positionLists?.map((pos, i) => (
                                    <CustomOverlayMap
                                        // key={`${pos.lat}-${pos.lng}`}
                                        key={i}
                                        position={{
                                            lat: pos.lat,
                                            lng: pos.lng,
                                        }}
                                    >
                                        <div
                                            className='map_marker_div'
                                            style={{
                                                cursor: 'pointer',
                                                background: selectPin === pos?.idx ? '#fff' : undefined,
                                                color: selectPin === pos?.idx ? '#565BD2' : undefined
                                            }}
                                            onClick={() => {
                                                setSelectPin(pos?.idx);

                                                if (setClusterIdx) {
                                                    if(isMobile){ // 모바일만
                                                        setClusterIdx([pos?.idx], 'list');
                                                    } else {
                                                        setClusterIdx([pos?.idx]);
                                                    }
                                                }
                                                setclurChk(true);
                                            }}
                                            id={pos?.idx}
                                        >
                                            1
                                            {/* <img src="./images/icons/map-marker-svgrepo-com.svg" width='24' /> */}
                                        </div>
                                    </CustomOverlayMap>
                                ))}
                            </MarkerClusterer>
                        }
                    </Map>
                }

                {showbtn &&
                    <div className='map_list_open'
                        onClick={() => {
                            // console.log('111111');
                            // return;
                            // 휴대폰일 경우에만
                            if(isMobile) {
                                mobileBackControl('list');
                            } 
                            // if(setShow) setShow(!show);
                        }}
                    >
                        <img src="./images/icons/list_check.svg" width='24' />
                    </div>
                }

                {/* 나중에 이미지 pc/모바일 이미지 경로 따로 */}
                {!is830 ?
                    <>
                        {memberinfos?.compony?.minicustombanner * 1 === 1 &&
                            <div className='advertisement_div'>
                                <img src={`${consts?.s3url}/${memberinfos?.compony?.minipcbanner}`} />
                            </div>
                        }
                    </>
                    :
                    <>
                        {memberinfos?.compony?.minicustombanner * 1 === 1 &&
                            <div className='advertisement_div_mobile'>
                                <img src={`${consts?.s3url}/${memberinfos?.compony?.minimobilebanner}`} />
                            </div>
                        }
                    </>
                }

                {!is830 &&
                    <div className='mini_home_bottom'>
                        <p className='title'>{memberinfos?.compony?.title}</p>

                        <div className='mini_home_info_box'>
                            <div className='flex_box'>
                                <p className='title'>주소</p>
                                <p className='text'>{memberinfos?.compony?.addr}</p>
                            </div>
                            <div className='flex_box'>
                                <p className='title'>대표번호</p>
                                {memberinfos?.compony?.company_phone &&
                                    <p className='text'>{hpHypen(memberinfos?.compony?.company_phone)}</p>
                                }
                            </div>

                        </div>

                        <div className='bar' />

                        <div className='mini_home_info_box'>
                            <div className='flex_box'>
                                <p className='title'>대표</p>
                                <p className='text'>{memberinfos?.compony?.ceo}</p>
                            </div>
                            <div className='flex_box'>
                                <p className='title'>사무소등록번호</p>
                                <p className='text'>{memberinfos?.compony?.business_number}</p>
                            </div>
                        </div>

                        <div style={{
                            display: "flex",
                            flexGrow: 1,
                            justifyContent: "end",
                            alignItems: "end",
                            gap: 4,
                        }}>
                            <img
                                style={{
                                    width: 170,
                                    height: 40,
                                    filter: 'grayscale(100%) brightness(80%)',
                                    cursor: "pointer"
                                }}
                                src='/images/logo.png'
                                onClick={() => {
                                    navigate("/")
                                }}
                            />
                            <span
                                style={{
                                    color: "#999",
                                    fontWeight: 700
                                }}
                            >
                                제공
                            </span>
                        </div>
                    </div>
                }
            </div>
        </>
    )
}
